import type { JSX, PropsWithChildren } from 'react';
import { useState } from 'react';

import type { Session } from '#src/shared/session';

import {
	MobileSignFormValuesContext,
	MobileSignFormCallbackContext,
} from '#src/app/pages/petitionDetails/shared/contexts';
import type { FormValues } from '#src/app/pages/petitionDetails/shared/types';
import { useLoginStateAsync } from '#src/app/shared/hooks/session';
import { isLoaded } from '#src/app/shared/utils/async';

export const MobileSignFormContextProvider = ({ children }: PropsWithChildren<EmptyProps>): JSX.Element => {
	const [storedState, setStoredState] = useState<FormValues | null>(null);
	const loginState = useLoginStateAsync();
	const loginStateLoaded = isLoaded(loginState);

	const [previousLoginState, setPreviousLoginState] = useState<Session['loginState']>('GUEST');

	if (loginStateLoaded && loginState.value !== previousLoginState) {
		setPreviousLoginState(loginState.value);
		setStoredState(null);
	}

	return (
		<MobileSignFormValuesContext value={storedState}>
			<MobileSignFormCallbackContext value={setStoredState}>{children}</MobileSignFormCallbackContext>
		</MobileSignFormValuesContext>
	);
};
